import { useWallet } from '@solana/wallet-adapter-react';
import { Wallet } from 'lucide-react';

import * as Form from '../../Form';

/** Read-only row: the connected wallet the new dApp (and its App NFT) is tied to. */
export function WalletField() {
  const { connected, publicKey } = useWallet();
  const address = connected && publicKey ? publicKey.toBase58() : null;

  return (
    <div className="flex flex-col gap-1">
      <Form.FieldLabel
        label="Your Solana Wallet"
        explanation="Your app must be associated with a wallet. This will not display on your dApp Store page."
      />
      <div className="flex h-10 items-center gap-2 rounded-lg border border-seeker-700 px-4 text-sm text-white">
        <Wallet
          className="size-4 shrink-0 text-seeker-400"
          aria-hidden="true"
        />
        {address ? (
          <span className="truncate font-mono">
            {`${address.slice(0, 5)}...${address.slice(-5)}`}
          </span>
        ) : (
          <span className="text-seeker-400">
            Connect a wallet to finish setup. You can save a draft without one.
          </span>
        )}
      </div>
    </div>
  );
}
